<template>
  <Modal :value="value" @hide="hide()" title="Create new repository">
    <template slot="body" class="content">
      <div class="margin-bottom-1">
        <BInput
          v-model="repoName"
          type="text"
          validation="required"
          placeholder="New repo name"
          name="name"
          focus="true"
          hideError="true"
          @enter="save()"
          @valid="valid = $event"
        ></BInput>
      </div>
      <div class="notification is-primary is-light">
        A repository is a service that stores packages.
        <br />
        <br />

        Built-in repositories in Deployify is secured with authentication. Keys
        will be generated for each user when shared.
      </div>

      <slot></slot>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div @click="save()" :disabled="!valid" class="button is-success">
          Save
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
export default {
  props: {
    value: Boolean,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
    BInput: () => import("@/components/singles/BInput/component.vue"),
  },
  data() {
    return {
      repoName: "",
      valid: false,
      isLoading: false,
    };
  },

  methods: {
    async save() {
      if (!this.isLoading && this.repoName != "") {
        this.isLoading = true;
        await this.$store.dispatch(
          "source/createInternal",
          this.repoName.trim()
        );
        this.isLoading = false;
        this.hide();
      }
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
